import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { syncInventoryCookie } from "./lib/activeInventory.js";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("no #root to mount on");

// Before the first render, so the first grid of thumbnails already carries it.
syncInventoryCookie();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * The service worker is what makes this installable. It is registered after
 * load so it never competes with the first paint, and it is skipped entirely in
 * development, where a cached shell is only ever confusing.
 */
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
